import { Link } from "react-router-dom";
import { FaCheckCircle, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import {
  fleetTypes,
  getNearbyText,
  whyChoosePoints,
} from "../data/suburbs";

const SuburbLandingContent = ({ suburb }) => {
  const nearbyText = getNearbyText(suburb);

  return (
    <main className='suburb-page'>
      <section className='suburb-hero suburb-hero--live'>
        <div className='suburb-hero__overlay' />
        <div className='container suburb-hero__inner'>
          <div className='suburb-hero__content'>
            <div className='suburb-breadcrumb'>
              <Link to='/suburbs'>Suburbs</Link>
              <span>/</span>
              <span>{suburb.name}</span>
            </div>
            <span className='suburb-badge suburb-badge--live'>Now Available</span>
            <h1>
              Car Rental {suburb.name} – Affordable Local Car Hire Near You
            </h1>
            <p className='suburb-hero__intro'>
              Looking for reliable and affordable car rental in {suburb.name}?
            </p>
            <p className='suburb-hero__intro suburb-hero__intro--secondary'>
              Flexible daily, weekly and long-term rentals from our Huntingdale
              depot — serving {suburb.name}, {nearbyText} and surrounding suburbs.
            </p>
            <div className='suburb-trust-row'>
              <span>No hidden fees</span>
              <span>Local Huntingdale depot</span>
              <span>Weekly & daily rates</span>
            </div>
            <div className='suburb-hero__actions'>
              <Link to='/request-quote' className='reserve-now-btn'>
                Request a Quote
              </Link>
              <a href='tel:0400920512' className='reserve-now-btn suburb-btn-outline'>
                Call Us
              </a>
            </div>
          </div>

          <aside className='suburb-hero__panel'>
            <p className='suburb-hero__panel-label'>Quick Contact</p>
            <a href='tel:0400920512' className='suburb-hero__panel-link'>
              <FaPhoneAlt aria-hidden='true' />
              0400 920 512
            </a>
            <p className='suburb-hero__panel-text'>
              Located in Huntingdale, serving {suburb.name}, {nearbyText} and
              surrounding suburbs.
            </p>
            <Link to='/request-quote' className='suburb-hero__panel-btn'>
              Get a Quote
            </Link>
          </aside>
        </div>
      </section>

      <section className='suburb-section'>
        <div className='container suburb-about'>
          <div className='suburb-about__copy'>
            <h2>Affordable Car Hire Near {suburb.name}</h2>
            <p>
              EZ Car Rentals provides convenient car hire just minutes from{" "}
              {suburb.name}, with a wide range of clean, well-maintained
              vehicles available for daily, weekly and long-term rental.
            </p>
            <p>
              Located nearby in Huntingdale, we proudly serve customers from{" "}
              {suburb.name}, {nearbyText} and surrounding suburbs with flexible
              rental options and friendly local service.
            </p>
          </div>

          <div className='suburb-features-block'>
            <h2>Why Choose EZ Car Rentals for {suburb.name} Car Hire?</h2>
            <ul className='suburb-why-list'>
              {whyChoosePoints.map((point) => (
                <li key={point}>
                  <FaCheckCircle aria-hidden='true' />
                  <span>
                    {point.replace(
                      "just minutes from Oakleigh",
                      `just minutes from ${suburb.name}`
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className='suburb-section suburb-section--dark'>
        <div className='container'>
          <div className='suburb-section__header suburb-section__header--light'>
            <h2>Our {suburb.name} Car Rental Fleet Includes:</h2>
            <p>
              Whether you need a rental car for work, family travel, insurance
              replacement or while your vehicle is off the road, EZ Car Rentals
              has a solution to suit your needs.
            </p>
          </div>
          <div className='suburb-fleet-grid'>
            {fleetTypes.map((type) => (
              <article className='suburb-fleet-card' key={type.label}>
                <span className='suburb-fleet-card__icon' aria-hidden='true'>
                  {type.icon}
                </span>
                <h3>{type.label}</h3>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className='suburb-section suburb-section--muted'>
        <div className='container suburb-location-block'>
          <div className='suburb-location-copy'>
            <span className='suburb-badge suburb-badge--dark'>Location</span>
            <h2>Conveniently Located Near {suburb.name}</h2>
            <p>
              Our Huntingdale depot is just a short drive from {suburb.name},
              making us a practical and affordable alternative to expensive
              airport rental providers.
            </p>
            <p>
              Book your {suburb.name} car rental today and experience easy,
              local car hire with no hidden fees.
            </p>
            <div className='suburb-address'>
              <FaMapMarkerAlt aria-hidden='true' />
              <span>33B Clifford Street, Huntingdale VIC 3166</span>
            </div>
          </div>

          <div className='suburb-card suburb-card--cta'>
            <h3>Ready to book in {suburb.name}?</h3>
            <p>Get a quote online or speak with our friendly local team today.</p>
            <div className='suburb-hero__actions suburb-hero__actions--stacked'>
              <Link to='/request-quote' className='reserve-now-btn'>
                Request a Quote
              </Link>
              <a href='tel:0400920512' className='reserve-now-btn suburb-btn-outline'>
                Call 0400 920 512
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SuburbLandingContent;
